import {Table, TableCell, TableRow} from "@mui/material";
import useOrganizations from "../../hooks/UseOrganizations";

export function Instructions() {
  const organizations = useOrganizations();

  return <>
    <Table>
      <TableRow>
        <TableCell><strong>Counter API URL (5.1):</strong></TableCell>
        <TableCell>https://sushi-510-production.usst-prod.thieme.de/r51</TableCell>
      </TableRow>
      <TableRow>
        <TableCell><strong>API Key:</strong></TableCell>
        <TableCell>API Keys can be created and managed in the section below.</TableCell>
      </TableRow>
      <TableRow>
        <TableCell><strong>Customer ID:</strong></TableCell>
        <TableCell>{organizations.length < 11 ? <ul>
          {organizations.map(o => <li key={o.id}>{o.name}: {o.id}</li>)}
        </ul> : "Customer IDs can be found within parentheses behind the organization name when selecting the organization inside the report interface."}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell><strong>Platform:</strong></TableCell>
        <TableCell>
          <ul>
            <li>thieme-connect (Thieme-Connect)</li>
            <li>eref-del (eRef Lehrbücher)</li>
            <li>medone-tebl (MedOne Education)</li>
            <li>roempp (Römpp)</li>
            <li>ps (Pharmaceutical Substances)</li>
          </ul>
        </TableCell>
      </TableRow>
    </Table>

    <p>You can find more detailed information in our <a target="_blank" href="/counter-user-guide-en.pdf">User Guide</a>. </p>
  </>;
}
